import { State } from 'model/State';
import hamsClient from 'modules/hams';
import { selectHamsClientConfig } from 'modules/auth/selectors';

import { baseConsentHubApiUrl } from '../..';

export const postToHamsClient = async (remainingPath: string, state: State) => {
  try {
    const config = selectHamsClientConfig(state);

    return (await hamsClient.post(`${baseConsentHubApiUrl}${remainingPath}`, {}, config)).data;
  } catch (error) {
    return Promise.reject(error);
  }
};
